import type { CreateSurveyParams, Survey } from 'app/common/types/surveys'
import type { Request } from '../../index'
import { convertSurvey, SurveyDto, apiDateFormat } from './common'
export { apiDateFormat } from './common'

const convertIds = (values?: Array<string>, single?: string) => {
  const selection = values || (single ? [single] : [])
  return selection.length ? selection.map(Number) : undefined
}

export const convertParams = (params: CreateSurveyParams) => [
  {
    title: params.title.trim(),
    starts_on: params.startsOn.getStringFormatted(apiDateFormat),
    ends_on: params.endsOn.getStringFormatted(apiDateFormat),
    city_ids: convertIds(params.scope.cityIds, params.scope.cityId),
    district_ids: convertIds(params.scope.districtIds, params.scope.districtId),
    school_ids: convertIds(params.scope.schoolIds, params.scope.schoolId),
    school_type: params.scope.schoolType || undefined,
    survey_kind: params.surveyKind,
    survey_location: params.surveyLocation,
  },
  undefined,
] as [Record<string, unknown>, void]

export const convertResult = (data: { survey: SurveyDto }): Survey => convertSurvey(data.survey)

export const POST_SURVEY: Request<CreateSurveyParams, Survey, void> = [
  'food/surveys',
  'post',
  ['data'],
]
